import { PointsProgram as PointsProgramStyles } from './PointsProgram.styles';
import { ScorePoints } from './ScorePoints';

export const PointsProgram = {
  ...PointsProgramStyles,
  ScorePoints,
};
